export default {
  "cat.shoes": "Chaussures",
  "cat.hoodies": "Hoodies / Sweats",
  "cat.tshirts": "T-shirts",
  "cat.jackets": "Vestes",
  "cat.pants": "Pantalons / Shorts",
  "cat.headwear": "Couvre-chefs",
  "cat.sets": "Ensembles",
  "cat.underwear": "Sous-vêtements",
  "cat.jersey": "Maillots",
  "cat.accessories": "Accessoires",
  "cat.bags": "Sacs",
  "cat.belts": "Ceintures",
  "cat.perfumes": "Parfums",
  "cat.other": "Autres articles",

  "cat.shoes.desc": "Baskets et chaussures",
  "cat.hoodies.desc": "Sweats et hoodies douillets",
  "cat.tshirts.desc": "T-shirts décontractés",
  "cat.jackets.desc": "Couches pour jours frais",
  "cat.pants.desc": "Joggers, pantalons et shorts",
  "cat.headwear.desc": "Casquettes, bonnets et plus",
  "cat.sets.desc": "Ensembles deux pièces",
  "cat.underwear.desc": "Basiques confortables",
  "cat.jersey.desc": "Maillots de match",
  "cat.accessories.desc": "Petits accessoires",
  "cat.bags.desc": "Sacs et tote bags",
  "cat.belts.desc": "Ceintures",
  "cat.perfumes.desc": "Parfums frais",
  "cat.other.desc": "Tout le reste que les fans adorent",

  "home.heroBadge": "Ressource indépendante de merch pour fans",
  "home.heroTitle": "US Fans Spreadsheet — Toutes les catégories de merch pour fans au même endroit",
  "home.heroSubtitle": "Parcourez les chaussures, maillots, hoodies et plus grâce à une ressource claire et organisée qui vous aide à trouver votre équipement préféré plus vite.",
  "home.heroCta1": "usfans spreadsheet",
  "home.heroCta2": "acheter maintenant",
  "home.heroTrust": "Liens rapides vers les catégories • Équipement sélectionné • Mis à jour régulièrement",

  "home.dropdownTitle": "Parcourir les catégories de merch pour fans",
  "home.dropdownSubtitle": "Choisissez une catégorie dans le menu pour accéder directement à cette collection sur notre boutique principale.",

  "home.categoriesTitle": "Explorez chaque catégorie",
  "home.categoriesSubtitle": "Touchez n'importe quelle catégorie pour ouvrir sa page de collection dédiée sur la boutique principale.",

  "home.aboutTitle": "Qu'est-ce que le US Fans Spreadsheet ?",
  "home.aboutP1": "Le US Fans Spreadsheet est une ressource organisée et facile à naviguer qui regroupe le merch pour fans dans des catégories clairement étiquetées. Au lieu de fouiller des pages dispersées, vous pouvez aller directement vers l'équipement que vous voulez — des chaussures et maillots aux hoodies, vestes, sacs et accessoires.",
  "home.aboutP2": "Chaque catégorie renvoie directement vers une collection sélectionnée sur notre boutique principale, pour que vous passiez moins de temps à chercher et plus de temps à trouver des pièces qui correspondent à votre style. Que vous cherchiez une nouvelle paire de baskets ou un ensemble assorti complet, tout est à un clic.",
  "home.aboutB1": "Du merch pour fans organisé au même endroit",
  "home.aboutB2": "Des liens directs vers chaque grande catégorie",
  "home.aboutB3": "Des conseils faciles pour débutants",
  "home.aboutB4": "Des collections mises à jour régulièrement",

  "home.guideTitle": "Guide à la une",
  "home.guideSubtitle": "Découvrez comment fonctionne cette ressource et comment choisir le bon équipement de fan.",
  "home.guideCategory": "Guide d'achat",
  "home.guideCardTitle": "Qu'est-ce que le US Fans Spreadsheet ? Un guide complet",
  "home.guideCardDesc": "Apprenez comment fonctionne cette ressource, quelles catégories sont disponibles et comment choisir le bon merch pour fans.",
  "home.guideRead": "Lire le guide",
  "home.guideTime": "6 min de lecture",
};